import userTable from './table';
import domainFactory from '../helper/domainFactory';
import actions from './actions';

export default domainFactory(
  {
    table: userTable,
    actions,
  },
  'user',
);
